import appGlobalScript from '/tmp/scratch/ticom-feature-components_7FIlH/src/global/index.ts';
export const globalScripts = appGlobalScript;
